"use client";

import { Provider } from "react-redux";
import { store } from "./store";
import { useAppDispatch, useAppSelector } from "@/hooks/useAppSelector";
import { useEffect } from "react";
import { fetchCart } from "./slices/cartSlice";
import { fetchShipping } from "./slices/addressSlice";
import { useRouter, usePathname } from "next/navigation";
import { fetchAvailableCredit } from "./slices/paymentSlice";
import { fetchManufacturers } from "./slices/homeSlice";
import {
  fetchUser,
  setBulkCreditLimit,
  setBulkUserID,
} from "./slices/authSlice";
import { getBulkUserID, getCreditLimit } from "@/utils/api";
import * as gtag from "@/lib/gtag";
import Script from "next/script";

function AppInitializer() {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const pathname = usePathname();
  const { cart } = useAppSelector((state) => state.cart);
  const { shippingData } = useAppSelector((state) => state.shipping);
  const { availableCredit } = useAppSelector((state) => state.payment);
  const { manufacturers } = useAppSelector((state) => state.home);
  const {
    bulkUserID,
    creditLimit,
    userData,
    phoneNumber,
    isAuthenticated,
    token,
  } = useAppSelector((state) => state.auth);

  // Track Google Analytics page views
  // useEffect(() => {
  //   if (pathname) {
  //     gtag.pageview(pathname); 
  //   }
  // }, [pathname]);

  useEffect(() => {
    if (!isAuthenticated && pathname !== "/auth") {
      router.push("/auth");
    }
  }, [isAuthenticated, token, pathname, router]);

  useEffect(() => {
    if (bulkUserID === null || bulkUserID === "") {
      dispatch(setBulkUserID(getBulkUserID()));
    }
    if (!creditLimit) {
      dispatch(setBulkCreditLimit(getCreditLimit()));
    }
    if (bulkUserID && !userData) {
      dispatch(fetchUser(bulkUserID));
    }
    if (bulkUserID && !availableCredit) {
      dispatch(fetchAvailableCredit(bulkUserID));
    }
    if (!manufacturers) {
      dispatch(fetchManufacturers());
    }
    if (!cart) {
      dispatch(fetchCart(phoneNumber));
    }
    if (!shippingData) {
      dispatch(fetchShipping(bulkUserID));
    }
  }, [
    dispatch,
    availableCredit,
    userData,
    cart,
    manufacturers,
    bulkUserID,
    shippingData,
    phoneNumber,
    creditLimit,
  ]);

  return null;
}

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <Provider store={store}>
      {/* <Script
        strategy="afterInteractive"
        src={`https://www.googletagmanager.com/gtag/js?id=${gtag.GA_TRACKING_ID}`}
      /> */}
      {/* <Script
        id="google-analytics"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${gtag.GA_TRACKING_ID}', {
              page_path: window.location.pathname,
            });
          `,
        }}
      /> */}
      <AppInitializer />
      {children}
    </Provider>
  );
}
